import React from "react";
import PropTypes from "prop-types";
import { Label } from "semantic-ui-react";
import { connect } from "react-redux";
import { isEmpty, get } from "lodash";
import moment from "moment";
import { getTimeLabel, getChatAlertName } from "@Utils/functionality";
import useAlert from "@Hooks/useAlert";
import IKModal from "@Components/IkModal";
import NewTable from "@Components/NewTable";
import TransferModal from "../Transfer";
import styles from "./styles.module.css";

const AlertCell = ({ chat, alerts, isHistoric }) => {
	const alert = useAlert(chat, alerts, isHistoric);
	if (!isEmpty(alert)) {
		let extraClass = "";
		switch (alert.name) {
			case "Vencido":
				extraClass = styles.alertTagVencida;
				break;
			case "En Atraso":
				extraClass = styles.alertTagAtraso;
				break;
			case "A Tiempo":
				extraClass = styles.alertTagATiempo;
				break;
			default:
				break;
		}
		return <Label className={`${styles.tag} ${extraClass}`}>{alert.name}</Label>;
	}
	return null;
};

AlertCell.propTypes = {
	chat: PropTypes.object,
	alerts: PropTypes.array,
	isHistoric: PropTypes.bool,
};

const ChatListTableModal = ({ open, onClose, chats, isHistoric, alerts }) => {
	const [selectedChats, setSelectedChats] = React.useState([]);
	const [openTransfer, setOpenTransfer] = React.useState(false);

	const chatsWithAlerts = React.useMemo(() => {
		return chats.map((chat) => {
			return {
				...chat,
				alert: getChatAlertName(chat, alerts, isHistoric),
				searchableAlert: `${getChatAlertName(chat, alerts, isHistoric)} ${
					getChatAlertName(chat, alerts, isHistoric) === "Vencido" ? "vencida" : ""
				} ${getChatAlertName(chat, alerts, isHistoric) === "En Atraso" ? "atrasada" : ""}`,
			};
		});
	}, [chats, alerts, isHistoric]);

	const renderTime = (chat) => {
		if (isHistoric) {
			const timestamp = get(chat, "closeDate", null);
			if (!timestamp) return "";
			const momentTime = moment(timestamp);
			return getTimeLabel(momentTime, "DD/MM/YYYY");
		}
		const timestamp = get(chat, "message.timestamp", null);
		if (!timestamp) return "";
		const momentTime = moment(timestamp);
		const diff = moment().diff(momentTime, "day");
		if (diff === 0) return getTimeLabel(momentTime, "h:mm A");
		return `${diff} días`;
	};

	if (!open) return null;

	return (
		<IKModal
			// mode="Edit"
			open={open}
			onClose={onClose}
			size="large"
			title={`Lista de Chats (${chats.length})`}
			fullHeight
			className={styles.modal}
			hideModeSwitch
			saveLabel="Continuar"
			onSuccess={() => {
				setOpenTransfer(true);
			}}
			saveDisabled={isEmpty(selectedChats)}>
			<div className={styles.tableContainer}>
				<NewTable
					columns={[
						{
							multiple: true,
							width: 0.5,
						},
						{
							label: "Plataforma",
							key: "channel.platform.name",
							canSort: false,
						},
						{
							label: "Tab",
							key: "state",
							canSort: false,
						},
						{
							label: "Estado",
							key: "searchableAlert",
							canSort: false,
							render: (row) => {
								return <AlertCell chat={row} alerts={alerts} isHistoric={isHistoric} />;
							},
						},
						{
							label: "Nombre",
							key: "contact.name",
							canSort: false,
						},
						{
							label: "Teléfono",
							key: "contact.phone",
							format: "phone",
							canSort: false,
						},
						{
							label: "Atiende",
							key: "user.fullName",
							canSort: false,
						},
						{
							label: "Grupo",
							key: "group.name",
							canSort: false,
						},
						{
							label: "Etiqueta",
							key: "tags,name",
							canSort: false,
							format: "arrayTruncate",
						},
						{
							label: "Tiempo",
							key: "time",
							canSort: false,
							headerPosition: "left",
							width: 16,
							render: (row) => {
								return renderTime(row);
							},
						},
					]}
					data={chatsWithAlerts}
					multipleSelected={selectedChats}
					onMultipleChange={(items) => {
						return setSelectedChats(items);
					}}
					pageRows={15}
					searchable
				/>
			</div>
			{openTransfer && (
				<TransferModal
					chatCurrent={selectedChats[0]}
					selectedChats={selectedChats}
					onClose={() => {
						setOpenTransfer(false);
					}}
					onTransferSuccess={() => {
						setSelectedChats([]);
						onClose();
					}}
					title={selectedChats.length > 1 ? "Transferir Conversaciones" : "Transferir Conversación"}
				/>
			)}
		</IKModal>
	);
};

ChatListTableModal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	chats: PropTypes.array,
	isHistoric: PropTypes.bool,
	alerts: PropTypes.array,
};

function mapStateToProps({ company }) {
	return { alerts: company.settings.alerts };
}

export default connect(mapStateToProps)(ChatListTableModal);
